import { Box, Text, TextInput, TextNew } from '@jfs/ui-new'
import { useEffect, useRef, useState } from 'react'
import { TextInput as RNTextInput } from 'react-native'
import { MobileNumberreg } from '../../util/util'
import { ModBox } from '../ModifiedBox/ModifiedBox'

const leftComponent = () => (
  <Box>
    <Text color="CLOUDY_GREY" type="h2">
      {'+91'}
    </Text>
  </Box>
)

export const MobileTextInput = (props: any) => {
  const inputTextField = useRef<RNTextInput>(null)

  const mobileNum = props?.value ?? ''
  const isMobileNumberAvailable = mobileNum?.length > 9

  const label = props?.label
  const maxLength = props?.maxLength
  const fieldName = props?.fieldName
  const placeholder = props?.placeholder
  const keyboardType = props?.keyboardType
  const inputMode = props?.inputMode
  const returnKeyType = props?.returnKeyType
  const setFieldValue = props?.setFieldValue

  const [textInputVal, updateTextInputVal] = useState(mobileNum)
  const [error, setError] = useState('')
  const isTFEditable = !isMobileNumberAvailable

  const onChange = (val: string) => {
    updateTextInputVal(val)
    setFieldValue(fieldName, val)
    setError('')
  }

  const onBlur = () => {
    if (textInputVal?.length < 10) {
      setError('Please enter 10 digit mobile number!')
    } else if (MobileNumberreg?.test(textInputVal) !== true) {
      setError('Please enter valid mobile number!')
    }
  }

  useEffect(() => {
    inputTextField?.current?.blur()
    setTimeout(() => {
      inputTextField?.current?.focus()
    }, 200)
  }, [isTFEditable, inputTextField])

  const showError = error !== '' && textInputVal > 0

  return (
    <>
      <TextInput
        placeholder={placeholder}
        value={textInputVal}
        onChangeText={onChange}
        maxLength={maxLength}
        keyboardType={keyboardType}
        inputMode={inputMode}
        label={label}
        editable={isTFEditable}
        autoFocus={isTFEditable}
        color="BLACK_75"
        onFocus={() => setError('')}
        innerRef={inputTextField}
        bottomLineColor={!showError ? 'DARK_GREY_BORDER' : 'ERROR'}
        error={props?.error}
        returnKeyType={returnKeyType}
        leftComponent={leftComponent()}
        onBlur={onBlur}
      />
      <ModBox pt={5} show={showError}>
        <TextNew type="body12" color="ERROR">
          {error}
        </TextNew>
      </ModBox>
    </>
  )
}

export default { MobileTextInput }
